// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.root[data-v-02591213] .unit-buy-price {\r\n\tmargin-right: -8px;\n}\n.root[data-v-02591213] .unit-buy-price input {\r\n\tmax-width: 80px;\r\n\ttext-align: right;\r\n\tpadding-right: 6px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
